import type { FaireProductEntity } from "../../entity_types/product";

export const p_xg2xg3ubv9: FaireProductEntity = {
  token: "p_xg2xg3ubv9",
  type: "product",
  name: "Gold Curb Chain Draped Hoop Earrings - Edgy Link Drop Studs",
  brandToken: "b_6hzxpxjqta",
  brandName: "Sparkling Extras",
  imageUrl: "https://cdn.faire.com/fastly/c1ac2f0063bf9f474b6b592582aa0dfab202550ac7facadc641c1a0a7d86e411.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2799efb26eb500e82b6ca05a4f8bb3678b6ea317bd2334637dd7e15b48e9914b.jpeg",
    "https://cdn.faire.com/fastly/d39d3d410f4c9a5f3ed3378ab489be38b18dcd1a38ea58941a2d18e33717c645.jpeg"
  ],
  priceDollars: 9.69,
  description: "Elevate your jewelry game with these stunning Draped Curb Chain Hoops. Featuring a high-polish gold finish, these earrings blend the classic look of a sleek huggie hoop with the rebellious edge of a chunky link chain. The unique draped design creates fluid movement that catches the light beautifully, making them the perfect statement piece for both day and night.",
  tags: [],
  msrpDollars: 19.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:41.873Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
